import Notification from "@Features/notification/components/Notification";
import React from "react";

interface TextAreFieldProps {
    label?: string,
    htmlId?: string,
    labelClassName?: string,
    placeholder?: string,
    value: string,
    onChange: (any) => void,
    onBlur?: (any) => void,
    textAreaClassName?: string
    style?: object,
    cols?: number
    rows?: number,
    limit?: number,
    showError?: boolean,
    errorMessage?: string,
}

function TextAreaField(props: TextAreFieldProps) {
    const {
        label,
        htmlId,
        labelClassName = "",
        placeholder,
        value,
        onChange,
        onBlur,
        textAreaClassName = "",
        style = {},
        cols = 90,
        rows = 10,
        limit = undefined,
        showError,
        errorMessage = "",
    } = props

    return (
        <div className="text-area">
            {label && (
                <label htmlFor={htmlId} className={labelClassName}>
                    {label}
                </label>
            )}
            <textarea
                placeholder={placeholder ?? label}
                maxLength={limit}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                className={textAreaClassName}
                style={style}
                cols={cols}
                rows={rows}
            />
            {showError && (
                <Notification notificationType="orange">
                    {errorMessage}
                </Notification>
            )}
        </div>
    )
}

export default TextAreaField